module.exports = __webpack_public_path__ + "static/pic04-9ccdfa22db580558c47e6663b5eea581.jpg";